import React from "react";
import Iframe from "react-iframe";

function Chart() {

    return (

        <div className="p-5 flex flex-col md:flex-row gap-2">
            <Iframe
                src="https://www.tradingview-widget.com/embed-widget/advanced-chart/?locale=vi_VN#%7B%22width%22%3A%22100%25%22%2C%22height%22%3A610%2C%22symbol%22%3A%22OANDA%3AXAUUSD%22%2C%22interval%22%3A%225%22%2C%22timezone%22%3A%22Asia%2FHo_Chi_Minh%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22allow_symbol_change%22%3Atrue%2C%22save_image%22%3Afalse%2C%22details%22%3Atrue%2C%22hotlist%22%3Atrue%2C%22calendar%22%3Afalse%2C%22hide_volume%22%3Atrue%2C%22support_host%22%3A%22https%3A%2F%2Fwww.tradingview.com%22%2C%22utm_source%22%3A%22giavang.net%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22advanced-chart%22%2C%22page-uri%22%3A%22giavang.net%2Fbieu-do-gia-vang-the-gioi-spot-gold%2F%23gsc.tab%3D0%22%7D"
                width="100%"
                height="800"
            />
            <Iframe
                src="https://www.tradingview-widget.com/embed-widget/advanced-chart/?locale=vi_VN#%7B%22width%22%3A%22100%25%22%2C%22height%22%3A610%2C%22symbol%22%3A%22OANDA%3AXAGUSD%22%2C%22interval%22%3A%225%22%2C%22timezone%22%3A%22Asia%2FHo_Chi_Minh%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22allow_symbol_change%22%3Atrue%2C%22save_image%22%3Afalse%2C%22details%22%3Atrue%2C%22hotlist%22%3Atrue%2C%22calendar%22%3Afalse%2C%22hide_volume%22%3Atrue%2C%22support_host%22%3A%22https%3A%2F%2Fwww.tradingview.com%22%2C%22utm_source%22%3A%22giavang.net%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22advanced-chart%22%2C%22page-uri%22%3A%22giavang.net%2Fbieu-do-gia-vang-the-gioi-spot-gold%2F%23gsc.tab%3D0%22%7D"
                width="100%"
                height="800"
            />
        </div>
    )
}

export default Chart;